export default "__VITE_ASSET__Baizm6FD__"